"use client";

import { CSVViewer } from "@/src/components/csv-viewer/csv-viewer";
import { PDFViewer } from "@/src/components/pdf-viewer/pdf-viewer";
import { isCsvContentType } from "@/src/lib/utils/csv";

export function FileViewer({
  url,
  filename,
  contentType,
  activePage,
  downloadDisabledReason,
}: {
  url: string;
  filename: string;
  contentType?: string | null;
  activePage?: number;
  downloadDisabledReason?: string;
}) {
  if (isCsvContentType(contentType)) {
    return <CSVViewer url={url} filename={filename} downloadDisabledReason={downloadDisabledReason} />;
  }

  return (
    <PDFViewer
      key={url}
      url={url}
      filename={filename}
      activePage={activePage}
      downloadDisabledReason={downloadDisabledReason}
    />
  );
}
